import type { ToasterProps } from 'sonner';
import { Toaster } from 'sonner';

const toastConfig: ToasterProps = {
  expand: false, // ensure the Toasts "stack" when there are multiple visible
  gap: 24, // space between Toasts when expanded (--wui-space-05)
  position: 'bottom-left', // ensure this value matches the Position type
  visibleToasts: 3, // number of Toasts to show at a time
};

export const ToastProvider = () => <Toaster {...toastConfig} />;
